import { BvtFeatureFlags, useBvtFlagsChecker } from '@telstra-connect/utils/bvt-feature-flags';
import { billingAppName } from '@telstra-connect/utils/data';
import * as React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

export type LocationType = ReturnType<typeof useLocation>;
export type ParamType = Record<string, string>;
export type navigateType = ReturnType<typeof useNavigate>;
export type FlagType = Record<string, boolean>
/** @deprecated Use `React Router hooks` instead */
export interface IWithRouterProps<L = LocationType, P = ParamType, N = navigateType, F = FlagType>{
    location: L;
    params: P;
    navigate: N;
    isSingleInvoice: F
}

/** @deprecated Use `React Router hooks` instead */
export const withRouter = <Props extends IWithRouterProps>(Component: React.ComponentType<Props>) => {
    const ComponentWithRouterProps = (props: Omit<Props, keyof IWithRouterProps>) => {
        const location = useLocation();
        const params = useParams();
        const navigate = useNavigate();
        const {isBvtFlagEnabled : isSingleInvoice} = useBvtFlagsChecker({
            appName: billingAppName,
            bvtFlagName: BvtFeatureFlags.TEDIG7717SingleInvoiceView,
        })

        return (
            <Component
                {...(props as Props)}
                params={params}
                navigate={navigate}
                location={location}
                isSingleInvoice={isSingleInvoice}
            />
        );
    }
    return ComponentWithRouterProps;
}
